import * as moment from 'moment';
import * as momentTz from 'moment-timezone';

import {CustomCode} from "./common.model";
import {JSonSerializer} from "./JSonSerializer";
import {HourFormatType, SortOrderType} from "../home/schedulePerEmployee/model/SchedulePrintConfig";

export class UserPreferences{
  private _map = new Map<string, UserPreference>();
  values = new Array<UserPreference>();

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('values' === propertyName) {
      for (const bean of <UserPreference[]> data) {
        const tmp = new UserPreference();
        serializer.deserialize(bean, tmp);
        if (tmp.prefName){
          this._map.set(tmp.prefName.code,tmp);
          this.values.push(tmp);
        }
      }
    }
  }

  public add(bean: UserPreference){
    this.values.push(bean);
    this._map.set(bean.prefName.code, bean);
  }

  public hasPref(name: PrefName) :boolean{
    if (this._map.has(name.code)){
      return true;
    }
    return false;
  }

  public getPref(name: PrefName): UserPreference{
    if (this._map.has(name.code)){
      return this._map.get(name.code);
    }
    return null;
  }

  public getPrefAsHour(name: PrefName): Date{
    const pref = this.getPref(name);
    if (pref){
      return moment(pref.prefValue,'HH:mm').toDate();
    }
    return null;
  }

}

export class UserPreference{
  username: string;
  prefName: PrefName;
  prefType =  PrefType.STRING;
  prefValue: string;
  canBeModified = true;
  displayOrder: number;

  modified  = false;
  maxValue? : number;
  minValue? : number;
  availableValues = new Array<string>();
 // customCodes

  public asNumber(): number{
    return +this.prefValue;
  }

  public asDate(): Date{
    return moment(this.prefValue).toDate();
  }

  public asBoolean():boolean{
    // console.log(this.prefName + ' booleanValue? ' + this.prefValue);
    if ('Y' === this.prefValue){
      return true;
    }
    return false;
  }

  public asTimeZone(){
    // import * as momentTz from 'moment-timezone';
    return momentTz.tz(this.prefValue);
    // return moment().tz(this.prefValue);
    // return momentTz(this.prefValue);
  }

  public asHour(AMPMFormat: boolean = false): Date {
    if (AMPMFormat){
      return moment(this.prefValue,'HH:mm a').toDate();
    }else{
      return moment(this.prefValue,'HH:mm').toDate();
    }
  }

  public asCustomCode(ifNullReturn?:any): any{
    return ifNullReturn;
  }

  public get customCodes() : any[] | null{
    return null;
  }


  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('availableValues' === propertyName) {
      // for (const bean of <CustomCode[]> data) {
      for (const bean of <string[]> data) {
        this.availableValues.push(bean);
      }
    }
  }



  _createSpecialElement(propertyName: string, data: any) {
    if ('prefType' === propertyName) {
      // weekStart: number; // Careful in Java Sunday is 1, not 0 like in MomentJs.
      this.prefType = PrefType.retrieveFromCode(data);
      return true;
    }
    if ('prefName' === propertyName) {
      // weekStart: number; // Careful in Java Sunday is 1, not 0 like in MomentJs.
      this.prefName = PrefName.retrieveFromCode(data);
      return true;
    }
    return false;
  }

}

export class SortOrderPreference extends UserPreference{

  private _customCodes = new Array<SortOrderType>();

  copy (bean: UserPreference){
    // console.log('Working on ' + JSON.stringify(bean,null,1));
    this.username = bean.username;
    this.prefName = bean.prefName;
    this.prefType = bean.prefType;
    this.prefValue = bean.prefValue;
    this.displayOrder = bean.displayOrder;
    this.modified = bean.modified;
    if (bean.availableValues){
      this.availableValues.push(...bean.availableValues);
    }
    for (const val of this.availableValues){
        this._customCodes.push(SortOrderType.retrieveFromCode(val));
    }

  }


  _createFromArray(propertyName: string, data: any) {
    // const serializer = new JSonSerializer();
    if ('availableValues' === propertyName) {
      for (const bean of <string> data) {
        const tmp = SortOrderType.retrieveFromCode(bean);
        this._customCodes.push(tmp);
      }
    }
  }

  public get customCodes() : SortOrderType[]{
    return this._customCodes;
  }

  public asCustomCode(ifNullReturn?:SortOrderType): SortOrderType{
    if (this.prefValue){
      const res = SortOrderType.retrieveFromCode(this.prefValue);
      if (res){
        return res;
      }
    }
    return ifNullReturn;
  }

}



export class HourFormatPreference extends UserPreference{

  private _customCodes = new Array<HourFormatType>();

  copy (bean: UserPreference){
    // console.log('Working on ' + JSON.stringify(bean,null,1));
    this.username = bean.username;
    this.prefName = bean.prefName;
    this.prefType = bean.prefType;
    this.prefValue = bean.prefValue;
    this.displayOrder = bean.displayOrder;
    this.modified = bean.modified;
    if (bean.availableValues){
      this.availableValues.push(...bean.availableValues);
    }
    for (const val of this.availableValues){
      this._customCodes.push(HourFormatType.retrieveFromCode(val));
    }

  }


  _createFromArray(propertyName: string, data: any) {
    // const serializer = new JSonSerializer();
    if ('availableValues' === propertyName) {
      for (const bean of <string> data) {
        const tmp = HourFormatType.retrieveFromCode(bean);
        this._customCodes.push(tmp);
      }
    }
  }

  public get customCodes() : HourFormatType[]{
    return this._customCodes;
  }

  public asCustomCode(ifNullReturn?:HourFormatType): HourFormatType{
    if (this.prefValue){
      const res = HourFormatType.retrieveFromCode(this.prefValue);
      if (res){
        return res;
      }
    }
    return ifNullReturn;
  }

}


export class PrefType extends CustomCode{
  private static _registered = new Map<string, PrefType>();

  static STRING = new PrefType('STRING');
  static BOOLEAN = new PrefType('BOOLEAN');
  static DATE = new PrefType('DATE');
  static INTEGER = new PrefType('INTEGER');
  static NUMBER = new PrefType('NUMBER');
  static HOUR = new PrefType('HOUR');
  static TIMEZONE = new PrefType('TIMEZONE');
  static SELECT_CUSTOM_CODE = new PrefType('SELECT_CUSTOM_CODE');

  static ALL = Array.from(PrefType._registered.values());


  constructor(code: string) {
    super(code);
    PrefType._registered.set(code, this);
  }


  static retrieveFromCode(code: string): PrefType {
    switch (code) {
      case 'STRING': return PrefType.STRING;
      case 'BOOLEAN': return PrefType.BOOLEAN;
      case 'DATE': return PrefType.DATE;
      case 'NUMBER': return PrefType.NUMBER;
      case 'INTEGER': return PrefType.INTEGER;
      case 'HOUR': return PrefType.HOUR;
      case 'TIMEZONE': return PrefType.TIMEZONE;
      case 'SELECT_CUSTOM_CODE': return PrefType.SELECT_CUSTOM_CODE;
    }
    return null;
  }

}



export class PrefName extends CustomCode{
  private static _registered = new Map<string, PrefName>();
  private static _allGrantable = new Map<string, PrefName>();


  static WORKSHIFT_DEFAULT_START_TIME = new PrefName('WORKSHIFT_DEFAULT_START_TIME',PrefType.HOUR,false);
  static WORKSHIFT_DEFAULT_END_TIME = new PrefName('WORKSHIFT_DEFAULT_END_TIME',PrefType.HOUR,false);

  static DEFAULT_MEAL_DURATION = new PrefName('DEFAULT_MEAL_DURATION',PrefType.INTEGER,false);
  static DEFAULT_BREAK_DURATION = new PrefName('DEFAULT_BREAK_DURATION',PrefType.INTEGER,false);

  static LATE_MIN_TIME = new PrefName('LATE_MIN_TIME',PrefType.INTEGER,false);
  static LATE_MAX_TIME = new PrefName('LATE_MAX_TIME',PrefType.INTEGER,false);
  static RUN_VALIDATION_PLAN_NB_WEEK = new PrefName('RUN_VALIDATION_PLAN_NB_WEEK',PrefType.INTEGER,false);
  static RUN_VALIDATION_EMPLOYEE_NB_WEEK = new PrefName('RUN_VALIDATION_EMPLOYEE_NB_WEEK',PrefType.INTEGER,false);
  static NB_WEEK_FOR_SCHEDULE = new PrefName('NB_WEEK_FOR_SCHEDULE',PrefType.INTEGER,false);
  static SHOW_HELP_WHEN_AVAILABLE = new PrefName('SHOW_HELP_WHEN_AVAILABLE',PrefType.BOOLEAN,false);
  static HIDE_LATE_ARRIVAL_PANEL = new PrefName('HIDE_LATE_ARRIVAL_PANEL',PrefType.BOOLEAN,false);
  static HIDE_TIMESHEET_PANEL = new PrefName('HIDE_TIMESHEET_PANEL',PrefType.BOOLEAN,false);
  static NB_DAY_FOR_TIMESHEET = new PrefName('NB_DAY_FOR_TIMESHEET',PrefType.INTEGER,false);

  static HIDE_EXPENSE_PANEL = new PrefName('HIDE_EXPENSE_PANEL',PrefType.BOOLEAN,false);
  static NB_DAY_FOR_EXPENSE = new PrefName('NB_DAY_FOR_EXPENSE',PrefType.INTEGER,false);


  static HIDE_PLAN_VALIDATION_PANEL= new PrefName('HIDE_PLAN_VALIDATION_PANEL',PrefType.BOOLEAN,false);
  static HIDE_SCHEDULE_VALIDATION_PANEL= new PrefName('HIDE_SCHEDULE_VALIDATION_PANEL',PrefType.BOOLEAN,false);

  static HIDE_BIRTHDAYS_VALIDATION_PANEL= new PrefName('HIDE_BIRTHDAYS_VALIDATION_PANEL',PrefType.BOOLEAN,false);
  static HIDE_SKILLS_VALIDATION_PANEL= new PrefName('HIDE_SKILLS_VALIDATION_PANEL',PrefType.BOOLEAN,false);


  static SAVED_TZ= new PrefName('SAVED_TZ',PrefType.TIMEZONE,false);

  static USE_SCHEDULE_ALIAS= new PrefName('USE_SCHEDULE_ALIAS',PrefType.BOOLEAN,false);
  static USE_TIMED_TASKS= new PrefName('USE_TIMED_TASKS',PrefType.BOOLEAN,true);

  static USE_ALTERNATE_UI= new PrefName('USE_ALTERNATE_UI',PrefType.BOOLEAN,false);
  static UI_VERSION= new PrefName('UI_VERSION',PrefType.STRING,false);


  static SHOW_CCQ_OPTION = new PrefName('SHOW_CCQ_OPTION',PrefType.BOOLEAN,true);

  static ESTABLISHMENT_DONE= new PrefName('ESTABLISHMENT_DONE',PrefType.BOOLEAN,false);

  static DEFAULT_SORT_ORDER= new PrefName('DEFAULT_SORT_ORDER',PrefType.SELECT_CUSTOM_CODE,false);

  static SHOW_PARAMS_PROFILE= new PrefName('SHOW_PARAMS_PROFILE',PrefType.BOOLEAN,false);

  static USE_UDATA_SERVICE= new PrefName('USE_UDATA_SERVICE',PrefType.BOOLEAN,true);

  static USE_RETAIL_NEXT_SERVICE= new PrefName('USE_RETAIL_NEXT_SERVICE',PrefType.BOOLEAN,true);

  static HOUR_FORMAT= new PrefName('HOUR_FORMAT',PrefType.SELECT_CUSTOM_CODE,false);

  static VALIDATE_OVERTIME= new PrefName('VALIDATE_OVERTIME',PrefType.BOOLEAN,false);

  static INCLUDE_VACATION_IN_AMOUNT_WHEN_AVAILABLE = new PrefName('INCLUDE_VACATION_IN_AMOUNT_WHEN_AVAILABLE',PrefType.BOOLEAN,false);

  static DISPLAY_SCHEDULE_TO_FILL = new PrefName('DISPLAY_SCHEDULE_TO_FILL',PrefType.BOOLEAN,false);

  static DISPLAY_AMOUNT = new PrefName('DISPLAY_AMOUNT',PrefType.BOOLEAN,false);

  static USE_ALLIERH_SERVICE= new PrefName('USE_ALLIERH_SERVICE',PrefType.BOOLEAN,true);

  static DISPLAY_DAY_SALES_COST_OBJECTIVE= new PrefName('DISPLAY_DAY_SALES_COST_OBJECTIVE',PrefType.BOOLEAN,false);

  static DISPLAY_EMPLOYEE_PROFILE_IMAGE = new PrefName('DISPLAY_EMPLOYEE_PROFILE_IMAGE',PrefType.BOOLEAN,false);

  static USE_SHIFT_BONUS = new PrefName('USE_SHIFT_BONUS',PrefType.BOOLEAN,true);

  static USE_GEO_FENCE = new PrefName('USE_GEO_FENCE',PrefType.BOOLEAN,true);

  static USE_BANK_TYPE = new PrefName('USE_BANK_TYPE',PrefType.BOOLEAN,true);

  static DISPLAY_PLAN_IN_SCHEDULE_PER_POSITION = new PrefName('DISPLAY_PLAN_IN_SCHEDULE_PER_POSITION',PrefType.BOOLEAN,false);

  static USE_SURVEYS = new PrefName('USE_SURVEYS',PrefType.BOOLEAN,true);
  static USE_SURVEYS_EXTRA = new PrefName('USE_SURVEYS_EXTRA',PrefType.BOOLEAN,false);

  static USE_API_ACCESS = new PrefName('USE_API_ACCESS',PrefType.BOOLEAN,true)
  static USE_CUSTOM_PREMIUM = new PrefName('USE_CUSTOM_PREMIUM',PrefType.BOOLEAN,true)

  static DEMO_ACCOUNT= new PrefName('DEMO_ACCOUNT',PrefType.BOOLEAN,false);
  static USE_REPORT_TO_EMAIL= new PrefName('USE_REPORT_TO_EMAIL',PrefType.BOOLEAN,true);
  static CAN_MODIFY_COST_DISTRIBUTION =  new PrefName('CAN_MODIFY_COST_DISTRIBUTION',PrefType.BOOLEAN,true);
  static USE_SYNC_API= new PrefName('USE_SYNC_API',PrefType.BOOLEAN,true);

  static PREFS_HIDE_INFORMATION_FOR_DEMOS = new PrefName('HIDE_INFORMATION_FOR_DEMOS',PrefType.BOOLEAN,true);
  static MANUAL_VALIDATION_SCHEDULE = new PrefName('MANUAL_VALIDATION_SCHEDULE',PrefType.BOOLEAN,true);

  static CAN_MODIFY_ALL_PAST_TS = new PrefName('CAN_MODIFY_ALL_PAST_TS',PrefType.BOOLEAN,false);
  static CAN_MODIFY_ALL_PAST_SCHEDULES = new PrefName('CAN_MODIFY_ALL_PAST_SCHEDULES',PrefType.BOOLEAN,false);


  static ACCOUNT_CAN_ADD_TEST_PUNCH = new PrefName('ACCOUNT_CAN_ADD_TEST_PUNCH',PrefType.BOOLEAN,true);

  static DISPLAY_MEMOS_BY_TYPE = new PrefName('DISPLAY_MEMOS_BY_TYPE',PrefType.BOOLEAN,false);

  static AUTO_SAVE_SCHEDULES = new PrefName('AUTO_SAVE_SCHEDULES',PrefType.BOOLEAN,false);

  static MAX_MENU_600 = new PrefName('MAX_MENU_600',PrefType.BOOLEAN,false);
  static MAX_MENU_800 = new PrefName('MAX_MENU_800',PrefType.BOOLEAN,false);
  static MAX_MENU_900 = new PrefName('MAX_MENU_900',PrefType.BOOLEAN,false);

  static DISPLAY_REQUEST_LIST = new PrefName('DISPLAY_REQUEST_LIST',PrefType.BOOLEAN,false);

  static USE_INTUIT_API = new PrefName('USE_INTUIT_API',PrefType.BOOLEAN,false);

  static FAVORITE_MENU = new PrefName('FAVORITE_MENU',PrefType.STRING,false);

  static CAN_READ_CONFIGURATION_API_V2 = new PrefName('CAN_READ_CONFIGURATION_API_V2',PrefType.BOOLEAN,false);
  static SMART_SEARCH = new PrefName('SMART_SEARCH',PrefType.BOOLEAN,false);
  static EDIT_IN_PLACE = new PrefName('EDIT_IN_PLACE',PrefType.BOOLEAN,false);

  

  static COPY_ONLY_SCHEDULE_WITH_DND = new PrefName('COPY_ONLY_SCHEDULE_WITH_DND',PrefType.BOOLEAN,false);


  static ACCOUNT_CAN_DELETE_UNAPPROVED_TS_IN_BATCH   = new PrefName('ACCOUNT_CAN_DELETE_UNAPPROVED_TS_IN_BATCH',PrefType.BOOLEAN,false);

  static EMPLOYEE_FILE_PANEL_OPEN_V2= new PrefName('EMPLOYEE_FILE_PANEL_OPEN_V2',PrefType.STRING,false);

  static CUSTOM_GROUP_CARBUR = new PrefName('CUSTOM_GROUP_CARBUR',PrefType.BOOLEAN,true);

  static IMPORT_SCHEDULES_FROM_ON_TRACK = new PrefName('IMPORT_SCHEDULES_FROM_ON_TRACK',PrefType.BOOLEAN,true);


  static ALL = Array.from(PrefName._registered.values());


  static ALL_GRANTABLE = Array.from(PrefName._allGrantable.values());


  private _type: PrefType;

  private _grantable = false;



  constructor(code: string,type: PrefType,grantable: boolean) {
    super(code);
    this._type = type;
    this._grantable = grantable;
    PrefName._registered.set(code, this);
    if (this._grantable===true){
      PrefName._allGrantable.set(code,this);
    }
  }

  public get grantable(){
    return this._grantable;
  }

  public get type(){
    return this._type;
  }

  static retrieveFromCode(code: string): PrefName {
    const res = PrefName._registered.get(code);
    if (!res) {
      console.log('Hmmm PrefName can\'t find ' + code);
    }
    return res;
  }

  public translateKey(){
    return 'PREFS_' + this.code;
  }

}

/*

export class ProvinceStateCode extends CustomCode {


  private static _registeredIso = new Map<string, ProvinceStateCode>();

  isoCode: string;


  static retrieveFromCode(code: string): ProvinceStateCode {
    const res = ProvinceStateCode._registered.get(code);
    if (!res) {
      console.log('Hmmm ProvinceStateCode can\'t find ' + code);
    }
    return res;
  }


  static retrieveByIsoCode(isoCode: string): ProvinceStateCode {
    const res = ProvinceStateCode._registeredIso.get(isoCode);
    if (!res) {
      console.log('Hmmm ProvinceStateCode can\'t find ' + isoCode);
    }
    return res;
  }

  constructor(code: string, isoCode: string) {
    super(code);
    this.isoCode = isoCode;
    ProvinceStateCode._registered.set(code, this);
    ProvinceStateCode._registeredIso.set(isoCode, this);
   // console.log('Registering ' + code + ': ' + this.isoCode);
  }

  public toString(): string {
    return this.code;
  }



}

 */

